// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quick-replies {
  display: flex;
  transition: 0.2s all ease;
  align-items: center;
  padding: 10px 8px;
  gap: 4px;
  -webkit-animation-name: fadeInUp;
  animation-name: fadeInUp;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
.quick-replies.full-width-buttons {
  flex-direction: column;
}
.quick-replies.full-width-buttons .kr-btn {
  width: 100%;
}
.quick-replies.stack-buttons {
  display: block;
}
.quick-replies.stack-buttons .kr-btn {
  display: block;
  width: auto;
  margin-bottom: 8px;
}
.quick-replies.stack-buttons .kr-btn .quickReplyIcon {
  height: 17px;
  width: 17px;
  border-radius: 50%;
  max-width: 34px;
}
.quick-replies.button-variation-1 .kr-btn {
  background: var(--button-temp-bg-variation-1);
  border: 1px solid var(--button-temp-variation-1-border);
  color: var(--button-temp-variation-1-color);
}
.quick-replies.button-variation-1 .kr-btn:hover {
  background: var(--button-temp-bg-variation-1-hover);
}
.quick-replies.button-variation-2 .kr-btn {
  background: var(--button-temp-bg-variation-2);
  border: 1px solid var(--button-temp-variation-2-border);
  color: var(--button-temp-variation-2-color);
}
.quick-replies.button-variation-2 .kr-btn:hover {
  background: var(--button-temp-bg-variation-2-hover);
}
.quick-replies .kr-btn {
  background: var(--button-temp-bg);
  border: 1px solid var(--button-temp-border);
  border-radius: 4px;
  padding: 9px 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  color: var(--button-temp-color);
  cursor: pointer;
  margin: 4px;
  text-align: center;
  transition: 0.2s all ease;
  white-space: nowrap;
}
.quick-replies .kr-btn:hover {
  background: var(--button-temp-bg-hover);
}
.quick-replies .quick-replies-buttons {
  display: flex;
  overflow: hidden;
  width: 100%;
}
.quick-replies .quick-replies-buttons .kr-btn {
  display: flex;
  align-items: center;
  gap: 6px;
}
.quick-replies .quick-replies-buttons .kr-btn .quickReplyIcon {
  height: 17px;
  width: 17px;
  border-radius: 50%;
  max-width: 34px;
}
.quick-replies .quick-left-click, .quick-replies .quick-right-click {
  border-radius: 32px;
  background: var(--sdk-global-white);
  box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);
  display: flex;
  width: 32px;
  height: 32px;
  padding: 0px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border: 0;
  cursor: pointer;
  flex-shrink: 0;
}
.quick-replies .quick-left-click svg path, .quick-replies .quick-right-click svg path {
  stroke: var(--sdk-gloabl-text-color);
}
.quick-replies .quick-left-click.hide, .quick-replies .hide.quick-right-click {
  cursor: not-allowed;
  pointer-events: none !important;
  opacity: 0.4;
}
.quick-replies .quick-left-click.remove, .quick-replies .remove.quick-right-click {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/templatemanager/templates/quickReplies/quickReplies.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,QAAA;EACA,gCAAA;EACA,wBAAA;EACA,8BAAA;EACA,sBAAA;EACA,iCAAA;EACA,yBAAA;AACJ;AAAI;EACI,sBAAA;AAER;AADQ;EACI,WAAA;AAGZ;AACI;EACI,cAAA;AACR;AACQ;EACI,cAAA;EACA,WAAA;EACA,kBAAA;AACZ;AAAY;EACI,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AAEhB;AAIQ;EACI,6CAAA;EACA,uDAAA;EACA,2CAAA;AAFZ;AAIY;EACI,mDAAA;AAFhB;AAQQ;EACI,6CAAA;EACA,uDAAA;EACA,2CAAA;AANZ;AAQY;EACI,mDAAA;AANhB;AAWI;EACI,iCAAA;EACA,2CAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;AATR;AAWQ;EACI,uCAAA;AATZ;AAaI;EACI,aAAA;EACA,gBAAA;EACA,WAAA;AAXR;AAYQ;EACI,aAAA;EACA,mBAAA;EACA,QAAA;AAVZ;AAWY;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;AATZ;AAcI;EACI,mBAAA;EACA,mCAAA;EACA,mDAAA;EACA,aAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,SAAA;EACA,SAAA;EACA,eAAA;EACA,cAAA;AAZR;AAcY;EACI,oCAAA;AAZhB;AAeQ;EACI,mBAAA;EACA,+BAAA;EACA,YAAA;AAbZ;AAeQ;EACI,aAAA;AAbZ","sourcesContent":[".quick-replies {\n    display: flex;\n    transition: 0.2s all ease;\n    align-items: center;\n    padding: 10px 8px;\n    gap: 4px;\n    -webkit-animation-name: fadeInUp;\n    animation-name: fadeInUp;\n    -webkit-animation-duration: 1s;\n    animation-duration: 1s;\n    -webkit-animation-fill-mode: both;\n    animation-fill-mode: both;\n    &.full-width-buttons {\n        flex-direction: column;\n        .kr-btn {\n            width: 100%;\n        }\n    }\n\n    &.stack-buttons {\n        display: block;\n\n        .kr-btn {\n            display: block;\n            width: auto;\n            margin-bottom: 8px;\n            .quickReplyIcon{\n                height: 17px;\n                width: 17px;\n                border-radius: 50%;\n                max-width: 34px;\n                }\n        }\n    }\n\n    &.button-variation-1 {\n        .kr-btn {\n            background: var(--button-temp-bg-variation-1);\n            border: 1px solid var(--button-temp-variation-1-border);\n            color: var(--button-temp-variation-1-color);\n\n            &:hover {\n                background: var(--button-temp-bg-variation-1-hover);\n            }\n        }\n    }\n\n    &.button-variation-2 {\n        .kr-btn {\n            background: var(--button-temp-bg-variation-2);\n            border: 1px solid var(--button-temp-variation-2-border);\n            color: var(--button-temp-variation-2-color);\n\n            &:hover {\n                background: var(--button-temp-bg-variation-2-hover);\n            }\n        }\n    }\n\n    .kr-btn {\n        background: var(--button-temp-bg);\n        border: 1px solid var(--button-temp-border);\n        border-radius: 4px;\n        padding: 9px 16px;\n        font-weight: 500;\n        font-size: 14px;\n        line-height: 17px;\n        color: var(--button-temp-color);\n        cursor: pointer;\n        margin: 4px;\n        text-align: center;\n        transition: 0.2s all ease;\n        white-space: nowrap;\n\n        &:hover {\n            background: var(--button-temp-bg-hover);\n        }\n    }\n    \n    .quick-replies-buttons {\n        display: flex;\n        overflow: hidden;\n        width: 100%;\n        .kr-btn{\n            display: flex;\n            align-items: center;\n            gap: 6px;\n            .quickReplyIcon{\n            height: 17px;\n            width: 17px;\n            border-radius: 50%;\n            max-width: 34px;\n            }\n        }\n    }\n\n    .quick-left-click {\n        border-radius: 32px;\n        background: var(--sdk-global-white);\n        box-shadow: 0px 4px 12px 2px rgba(32, 33, 36, 0.12);\n        display: flex;\n        width: 32px;\n        height: 32px;\n        padding: 0px;\n        justify-content: center;\n        align-items: center;\n        gap: 10px;\n        border: 0;\n        cursor: pointer;\n        flex-shrink: 0;\n        svg{\n            path{\n                stroke: var(--sdk-gloabl-text-color);\n            }\n        }\n        &.hide {\n            cursor: not-allowed;\n            pointer-events: none !important;\n            opacity: 0.4;\n        }\n        &.remove {\n            display: none;\n        }\n    }\n\n    .quick-right-click {\n        @extend .quick-left-click;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
